module.exports = __webpack_public_path__ + "static/media/litter_icon_selected.1ec020c1.svg";